import axios from "axios";
import { Base_URL } from "../url";
import { toast } from "react-toastify";


export const createNodes = async (nodeData, userName) => {

  try {
    console.log(nodeData, 'nodeData', userName)
    // return
    const output = {
      parentNodeName: nodeData.parentNodeName,
      roleIds: nodeData.roleIds.map(r => r.value).join(","),
      child_Fields: nodeData.child_fields.map(child => ({
        parentNodeID: "",
        childNodeName: child.childNodeName,
        childNodeRoles: child.childNodeRoles.map(r => r.value).join(","),
        nodeUrl: child.childNodeUrl
      }))
    };
    // return
    const response = await axios.post(
      `${Base_URL}/SidebarParentNode/CreateSidebarNode?userName=${userName}`,
      output);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to save Asset Master";
  }
};

export const fetchNodes = async () => {
  try {
    const response = await axios.get(`${Base_URL}/SidebarParentNode/GetAllActiveNodes`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching items!";
  }
};